
import { useNavigate } from 'react-router-dom'

import './_terms.scss'

const ContentModerationPolicy = () => {
  const navigate = useNavigate()

  return (
    <>
    <div className="pf-content pf-content--not-home">
        <div className="pf-content__inner">
        <div className="pf-container">
            <h2 className="pf-page__title">
             Content Moderation Policy
            </h2>
            <div className="pf-page__descr">

            <h5></h5>
                <p>The Innodev Solutions Inc. (“AllFans”) Content Moderation Policy explains our use of third-party and human moderation to enforce 
                    our <a href='/terms' className='terms-link' onClick={(e) => { e.preventDefault(); navigate('/terms') }}>Terms of Service</a> and <a href='/terms' className='terms-link' onClick={(e) => { e.preventDefault(); navigate('/acceptableuse') }}>Acceptable Use Policy</a> which describe what is and is not permitted on our platform. We utilize VerifyMyContent, a 
                    third party content moderation technology in addition to human moderation to actively review and monitor all content uploaded 
                    to the Site, including text, audio, images and videos. All Content is reviewed prior to being published and regularly monitored 
                    to ensure all Content complies with these Terms of Service, the Innodev Solutions Inc. and applicable laws. Any violative Content, 
                    including without limitation, Content that is harmful, unlawful, offensive, or otherwise objectionable, will be rejected and/or 
                    immediately removed from the Site. The consequences to you of uploading or attempting to upload Content that violates the 
                    Innodev Solutions Inc. this policy and or our terms of service may include, in our sole discretion, the issuance of a warning, 
                    termination of your account, and/or banning you from using the Site (as a user). If the Content involves illegal activity or 
                    the depiction of a minor we will report the Content to the relevant authorities, as appropriate. Note we are permitted to 
                    moderate Content in this fashion without being responsible for said Content or legally liable for our moderation activities. 
                    We expressly waive any and all such liability. To appeal a decision involving the moderation or removal of your Content, or 
                    for inquiries related to content moderation or removal, you may contact us at <a href='mailto:support@allfans.com' className='terms-link'>support@allfans.com</a>.</p>
                <p>For information on VerifyMyContent’s processing of data, please see <a href='https://verifymycontent.co.uk/privacy' className='terms-link'>https://verifymycontent.co.uk/privacy</a>
                . Any questions or requests regarding the processing of data can be directed to <a href='mailto:info@verifymycontent.com' className='terms-link'>info@verifymycontent.com</a></p>

            </div>

            <div style={{ paddingTop: '240px' }}></div>
          </div>
          </div>
    </div>
        </>
  );
};

export default ContentModerationPolicy;
